import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const panApi = createAsyncThunk("pan", async () => {
  const response = await axiosInstance.get("/pan");
  return response.data;
});

const panSlice = createSlice({
  name: "pan",
  initialState: {
    pan: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(panApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(panApi.fulfilled, (state, action) => {
        state.pan = action.payload;
        state.loading = false;
      })
      .addCase(panApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default panSlice.reducer;
